export default "__VITE_ASSET__D0r1xESy__"